import React, { useEffect, useMemo, useState } from 'react';
import Swal from 'sweetalert2';

function createPageLocally(newPage) {
  try {
    const raw = localStorage.getItem('localFacebookPages');
    const parsed = raw ? JSON.parse(raw) : [];
    const next = Array.isArray(parsed) ? [...parsed, newPage] : [newPage];
    localStorage.setItem('localFacebookPages', JSON.stringify(next));
  } catch {}
}

const STATIC_PAGE = {
  id: '748375848357662',
  name: 'Mahadev jana',
  isStatic: true,
};

function readLocalPages() {
  try {
    const raw = localStorage.getItem('localFacebookPages');
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) return parsed;
    return [];
  } catch {
    return [];
  }
}

function writeLocalPages(pages) {
  localStorage.setItem('localFacebookPages', JSON.stringify(pages));
}

export default function FacebookPages() {
  const [localPages, setLocalPages] = useState(() => {
    const list = readLocalPages();
    const staticDeleted = localStorage.getItem('staticPageDeleted') === '1';
    if (!staticDeleted && !list.some((p) => p.id === STATIC_PAGE.id)) {
      list.unshift(STATIC_PAGE);
    }
    return list;
  });
  const [showCreate, setShowCreate] = useState(false);
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({
    name: '',
    category: 'Local Business or Place',
    phone: '',
    website: '',
  });
  const categories = [
    'Local Business or Place',
    'Company, Organization or Institution',
    'Brand or Product',
    'Artist, Band or Public Figure',
    'Entertainment',
    'Cause or Community',
    'McNutt & Partners',
    'Boostlikes',
  ];

  // pages are fully represented in localPages (including the static one when not deleted)

  useEffect(() => {
    const handleCreated = (e) => {
      const created = e?.detail;
      if (created && created.id) {
        setLocalPages((prev) => {
          const next = [...prev, created];
          writeLocalPages(next);
          return next;
        });
      }
    };
    window.addEventListener('facebookPageCreated', handleCreated);
    return () => window.removeEventListener('facebookPageCreated', handleCreated);
  }, []);

  const handleDelete = async (page) => {
    const result = await Swal.fire({
      title: 'Delete this page?',
      text: `This will remove ${page.name}.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it',
    });
    if (!result.isConfirmed) return;
    setLocalPages((prev) => {
      const next = prev.filter((p) => p.id !== page.id);
      if (page.id === STATIC_PAGE.id) {
        try { localStorage.setItem('staticPageDeleted', '1'); } catch {}
      }
      writeLocalPages(next);
      return next;
    });
    Swal.fire({ title: 'Deleted!', text: 'Page has been removed.', icon: 'success', timer: 1200, showConfirmButton: false });
  };

  return (
    <div className='container-fluid '>
      <div className="card shadow-sm" style={{ borderRadius: 12, overflow: 'hidden', background: '#fff', border: '1px solid #eef2f7' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', background: '#f7fafc', borderBottom: '1px solid #eef2f7' }}>
        <div style={{ fontWeight: 700, color: '#1f2937' }}>Facebook Pages</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ fontSize: 12, color: '#6b7280' }}>Manage your connected pages locally</div>
          <button className="btn btn-success btn-sm" onClick={() => setShowCreate(true)}>Create</button>
        </div>
      </div>
      <div style={{ padding: 16 }}>
        <div className="table-responsive">
          <table className="table" style={{ marginBottom: 0 }}>
            <thead>
              <tr>
                <th style={{ whiteSpace: 'nowrap' }}>Page Name</th>
                <th style={{ whiteSpace: 'nowrap' }}>Page ID</th>
                <th style={{ whiteSpace: 'nowrap' }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {localPages.map((page) => (
                <tr key={page.id}>
                  <td style={{ fontWeight: 600 }}>{page.name}</td>
                  <td><code>{page.id}</code></td>
                  <td>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => handleDelete(page)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
              {localPages.length === 0 && (
                <tr>
                  <td colSpan="3" style={{ color: '#6b7280' }}>No pages</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {showCreate && (
        <div className="blur-background d-flex justify-content-center align-items-center" style={{position: 'fixed',top: 0,left: 0,height: '100vh',width: '100vw',zIndex: 2050,background: 'rgba(0,0,0,0.18)'}}>
          <div className="card shadow-lg border-0" style={{width: 520, maxWidth: '95vw', borderRadius: 18, boxShadow: '0 8px 32px 0 rgba(33,191,6,0.13)', maxHeight: '90vh', overflowY: 'auto', position: 'relative'}}>
            <button type="button" aria-label="Close" className='btn btn-light position-absolute' style={{top: 18, right: 18, borderRadius: '50%', width: 32, height: 32, padding: 0, fontSize: 18, boxShadow: '0 1px 4px rgba(0,0,0,0.08)'}} onClick={() => !creating && setShowCreate(false)}>
              &times;
            </button>
            <div className="card-body">
              <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 12 }}>Create Facebook Page</div>
              <div className="mb-3">
                <label className="form-label">Page Name</label>
                <input className="form-control" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} disabled={creating} placeholder="Enter page name" />
              </div>
              <div className="mb-3">
                <label className="form-label">Category</label>
                <select className="form-select" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} disabled={creating}>
                  {categories.map((c) => (
                    <option key={c} value={c}>{c}</option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">Phone Number</label>
                <input className="form-control" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} disabled={creating} placeholder="Optional" />
              </div>
              <div className="mb-3">
                <label className="form-label">Website</label>
                <input className="form-control" value={form.website} onChange={(e) => setForm({ ...form, website: e.target.value })} disabled={creating} placeholder="Optional" />
              </div>
              <div className="d-flex justify-content-end gap-2">
                <button className="btn btn-light" onClick={() => setShowCreate(false)} disabled={creating}>Cancel</button>
                <button className="btn btn-success" disabled={creating || !form.name.trim()} onClick={() => {
                  setCreating(true);
                  const newPage = {
                    id: String(Date.now()),
                    name: form.name.trim(),
                    category: form.category,
                    phone: form.phone.trim(),
                    website: form.website.trim(),
                  };
                  setTimeout(() => {
                    createPageLocally(newPage);
                    window.dispatchEvent(new CustomEvent('facebookPageCreated', { detail: newPage }));
                    setCreating(false);
                    setShowCreate(false);
                    setForm({ name: '', category: 'Local Business or Place', phone: '', website: '' });
                  }, 5600);
                }}>
                  {creating ? 'Creating...' : 'Create'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
    </div>
  );
}


